/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SmartForm } from 'components';
import { saveSetting, getSetting } from 'rdx/config';
import { valueToInteger } from 'utils';

import checkoutSettingsSchema from './checkoutSettingsSchema';
import './checkoutSettings.scss';

function ProductSettings() {
  const settingsFormRef = React.useRef(null);
  const dispatch = useDispatch();
  const [configState, setConfigState] = useState({});

  const touchpos_require_card_type_on_external_payment = useSelector(
    getSetting('touchpos_require_card_type_on_external_payment'),
  );
  const touchpos_ask_signature_for_integrated_payments = useSelector(
    getSetting('touchpos_ask_signature_for_integrated_payments'),
  );
  const touchpos_disable_external_card_payment = useSelector(
    getSetting('touchpos_disable_external_card_payment'),
  );
  const pos_round_cash_to_nearest_x = useSelector(
    getSetting('pos_round_cash_to_nearest_x'),
  );
  const pos_round_cash_to_nearest_005 = useSelector(
    getSetting('pos_round_cash_to_nearest_005'),
  );
  const pos_use_giftcards_with_serial_numbers = useSelector(
    getSetting('pos_use_giftcards_with_serial_numbers'),
  );
  const touchpos_disable_order_to_cashinvoice = useSelector(
    getSetting('touchpos_disable_order_to_cashinvoice'),
  );
  const touchpos_disable_new_order_to_cashinvoice = useSelector(
    getSetting('touchpos_disable_new_order_to_cashinvoice'),
  );

  const touchpos_enable_edit_name_in_order = useSelector(
    getSetting('touchpos_enable_edit_name_in_order'),
  );
  const touchpos_enable_local_server_print = useSelector(
    getSetting('touchpos_enable_local_server_print'),
  );
  const touchpos_print_cash_in_out_receipt = useSelector(
    getSetting('touchpos_print_cash_in_out_receipt'),
  );
  const cash_inout_open_drawer = useSelector(
    getSetting('cash_inout_open_drawer'),
  );
  const touchpos_always_open_drawer_after_sale = useSelector(
    getSetting('touchpos_always_open_drawer_after_sale'),
  );
  useEffect(() => {
    setConfigState({
      touchpos_enable_edit_name_in_order,
      touchpos_require_card_type_on_external_payment,
      touchpos_ask_signature_for_integrated_payments,
      touchpos_disable_external_card_payment,
      pos_round_cash_to_nearest_x,
      pos_round_cash_to_nearest_005,
      pos_use_giftcards_with_serial_numbers,
      touchpos_disable_order_to_cashinvoice,
      touchpos_enable_local_server_print,
      touchpos_print_cash_in_out_receipt,
      cash_inout_open_drawer,
      touchpos_always_open_drawer_after_sale,
      touchpos_disable_new_order_to_cashinvoice,
    });
  }, [
    touchpos_enable_edit_name_in_order,
    touchpos_require_card_type_on_external_payment,
    touchpos_ask_signature_for_integrated_payments,
    touchpos_disable_external_card_payment,
    pos_round_cash_to_nearest_x,
    pos_round_cash_to_nearest_005,
    pos_use_giftcards_with_serial_numbers,
    touchpos_disable_order_to_cashinvoice,
    touchpos_enable_local_server_print,
    touchpos_print_cash_in_out_receipt,
    cash_inout_open_drawer,
    touchpos_always_open_drawer_after_sale,
    touchpos_disable_new_order_to_cashinvoice,
  ]);

  const submitSetting = () => {
    const { values: currentValues } = settingsFormRef.current;

    Object.entries(currentValues).forEach(([key, value]) => {
      const payload = {};

      payload.parameterName = key;
      payload.parameterValue =
        typeof value === 'boolean' ? valueToInteger(value) : value;

      if (payload.parameterValue !== configState[key])
        dispatch(saveSetting(payload));
    });
  };
  return (
    <SmartForm
      grid
      ref={settingsFormRef}
      state={configState}
      autosave
      fields={checkoutSettingsSchema}
      handleSubmit={submitSetting}
      className="checkout-form"
    />
  );
}

export default ProductSettings;
